import { classNames } from "components/utils";
import React from "react";

interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (res: boolean) => void;
  id?: string;
  className?: string;
  description?: string;
  labelClassName?: string;
}

const Checkbox: React.FC<CheckboxProps> = (props) => (
  <div className="relative flex items-start">
    <div className="flex h-5 items-center">
      <input
        id={props.id ? props.id : props.label}
        aria-describedby="offers-description"
        name={props.id ? props.id : props.label}
        type="checkbox"
        checked={props.checked}
        onChange={(e) => props.onChange(e.target.checked)}
        className={`h-4 w-4 rounded border-gray-300 text-cyan-600 focus:ring-highlightLighter ${props.className}`}
      />
    </div>
    <div className="ml-3 text-sm">
      <label
        htmlFor={props.id ? props.id : props.label}
        className={classNames(
          `font-medium text-gray-700 dark:text-cyan-100`,
          props.labelClassName ? props.labelClassName : ""
        )}
      >
        {props.label}
      </label>
      {props.description && (
        <p
          id={`${props.id ? props.id : props.label}-description`}
          className="text-gray-500 dark:text-cyan-100"
        >
          {props.description}
        </p>
      )}
    </div>
  </div>
);

export default Checkbox;
